import { Controller } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

const BaseInput = (props) => {
    const {
        id,
        name,
        label,
        labelClassName,
        type,
        required = false,
        errors,
        className,
        inputClassName,
        disabled = false,
        readOnly = false,
        placeholder,
        control,
        clearErrors,
        value,
        setValue,
        onKeyDown
    } = props;

    const errorClassname = errors?.length ? 'border-theme1-error' : '';

    return (
        <div className={twMerge('w-full', className)}>
            {label && (
                <div className={twMerge('text-theme1-primary2 font-bold text-base mb-1', labelClassName)}>{label}</div>
            )}
            {control && (
                <Controller
                    render={({ field }) => (
                        <input
                            id={id ?? name}
                            name={name}
                            type={type}
                            autoComplete={name}
                            value={field.value ?? ''}
                            onChange={(e) => {
                                field.onChange(e);
                                if (clearErrors) {
                                    clearErrors(name);
                                }
                            }}
                            onKeyDown={onKeyDown}
                            required={required}
                            disabled={disabled}
                            readOnly={readOnly}
                            className={twMerge(
                                'text-theme1-text1 rounded-2xl border px-4 py-2 border-theme1-text3 w-full outline-none',
                                errorClassname,
                                inputClassName
                            )}
                            placeholder={placeholder ?? label}
                        />
                    )}
                    control={control}
                    name={name}
                />
            )}

            {!control && (
                <input
                    id={id ?? name}
                    name={name}
                    type={type}
                    autoComplete={name}
                    value={value}
                    onChange={(e) => {
                        if (setValue) {
                            setValue(e.target.value);
                        }
                    }}
                    onKeyDown={onKeyDown}
                    required={required}
                    disabled={disabled}
                    readOnly={readOnly}
                    className={twMerge(
                        'text-theme1-text1 rounded-2xl border px-4 py-2 border-theme1-text3 w-full outline-none',
                        errorClassname,
                        inputClassName
                    )}
                    placeholder={placeholder ?? label}
                />
            )}

            {errors &&
                errors.map((error) => {
                    return (
                        <div key={error} className='mt-2.5 text-theme1-error'>
                            {error}
                        </div>
                    );
                })}
        </div>
    );
};

export default BaseInput;
